import { useEffect, useRef } from "react";
import styles from "./Valpay.module.css";
import "@adyen/adyen-web/styles/adyen.css";
import classNames from "classnames";

interface PaymentMethodsProps {
  className?: string;
  valpayObj?: { mount: (el: string | HTMLElement) => unknown; unmount: () => void } | null;
}

function PaymentMethods({ className, valpayObj }: PaymentMethodsProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Only initiate ValPay if we are ready to do so.
    if (!valpayObj) return;
    if (containerRef.current) valpayObj.mount(containerRef.current);

    return () => {
      try {
        valpayObj.unmount();
      } catch (e) {
        // Ignore errors if already unmounted
      }
    };
  }, [valpayObj]);

  return <div className={classNames(className, styles.dropin)} ref={containerRef} />;
}

export default PaymentMethods;
